import { type AxiosRequestConfig, httpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';

export interface CreateRatingOrderBody {
  rated_by: string; // user or supplier
  rating: number; // 1-5
  comment?: string;
  badge_ids?: string[]; // array of badge ids
}

export const createRatingOrder = async (
  orderId: string,
  body: CreateRatingOrderBody,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.put(
    apiRoutes.order.rateOrder(orderId),
    body,
    config
  );
  return response.data;
};
